import React, { useEffect } from "react";
import { Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import LandingPage from "pages/Landing/LandingPage";
import ProductListingPage from "pages/ProductListing/ProductListingPage";
import ProductDetailsPage from "pages/Product/ProductDetailsPage";
import CategoryPage from "pages/category/CategoryPage";
import Navbar from "./component/Navbar";
import MobileBottomNav from "./component/MobileBottomNav";
import Footer from "./component/Footer";
import "./assets/styles.css";
import "./assets/new.css";
import CartPage from "pages/Cart/CartPage";
import AddressPage from "pages/Address/AddressPage";
import About from "pages/about/About";
import Checkout from "pages/checkout/checkout";
import Login from "pages/login/Login";
import Order from "pages/order/Order";
import Orderdetail from "pages/orderdetail/Orderdetail";
import UserAddscreen from "pages/useraddscreen/UserAddscreen";
import UserProfile from "pages/userprofile/UserProfile";
import PassWordPage from "pages/login/PassoWordPage";
import OtpPage from "pages/login/OtpPage";
import SignUp from "pages/login/SignUp";
import ComboData from "pages/combos/ComboData";
import MostWanted from "pages/mostWanted/MostWanted";
import NewAddition from "pages/newAddtion/NewAddition";
import PrivateRoute from "component/privateRoute/PrivateRoute";
import Confirm from "pages/orderConfirm/Confirm";
import Service from "./services/service";
import { globalStore } from "./stores/globalStore";

// Reusable function to check authentication
const isAuthenticated = () => {
  return !!sessionStorage.getItem("authToken");
};

function App() {
  const { setProductOverviewData } = globalStore();
  const location = useLocation();
  const navigate = useNavigate();

  // Remove trailing slashes to prevent duplicate URLs
  useEffect(() => {
    if (location.pathname !== "/" && location.pathname.endsWith("/")) {
      navigate(location.pathname.slice(0, -1) + location.search, { replace: true });
    }
  }, [location.pathname]);

  useEffect(() => {
    const fetchProductOverview = async () => {
      try {
        const response = await Service.getAllProductSearchService();
        setProductOverviewData(response.data); // Store data in global state
      } catch (error) {
        console.error("Error fetching product overview data:", error);
      }
    };

    fetchProductOverview();
  }, [setProductOverviewData]);

  return (
    <div>
      {/* Common Components */}
      <Navbar />
      {/* Routes */}
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/productlisting" element={<ProductListingPage />} />
        <Route path="/combos" element={<ComboData />} />
        <Route path="/wanted" element={<MostWanted />} />
        <Route path="/addition" element={<NewAddition />} />

        <Route path="/product/:id" element={<ProductDetailsPage />} />
        <Route path="/collections/:slug" element={<CategoryPage />} />
        <Route path="/address" element={<AddressPage />} />
        {/* <Route path='/slider' element={<SliderComponent/>}/> */}
        <Route path="/About" element={<About />} />
        <Route path="/OrderConfirm" element={<Confirm />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/Order" element={<Order />} />
        <Route path="/Orderdetail" element={<Orderdetail />} />
        <Route path="/UserAddscreen" element={<UserAddscreen />} />
        <Route path="/password" element={<PassWordPage />} />
        <Route path="/otp" element={<OtpPage />} />

        {/* Protected Routes */}
        <Route
          path="/cart"
          element={
            <PrivateRoute>
              <CartPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/Checkout"
          element={
            <PrivateRoute>
              <Checkout />
            </PrivateRoute>
          }
        />

        <Route
          path="/userprofile"
          element={
            <PrivateRoute>
              <UserProfile />
            </PrivateRoute>
          }
        />
      </Routes>
      
      <Footer />
      <MobileBottomNav />
    </div>
  );
}

export default App;
